<template>
    <div class="deatilInfo">
        <Commondtitle :title="name" />
        <div class="dea_content">
            <h2>{{ dataObj.fmessageTitle || dataObj.flawTitle }}</h2>
            <div v-html="dataObj.fmessageContent || dataObj.flawContent"></div>

        </div>
        <div class="dea_fujian" v-if="fujian">
            <p>附件:</p>
            <ul>
                <li v-for="(item,index) in (dataObj.fmessageFileUrl2 || dataObj.flawFileUrl2)" :key="index">
                    <a target="_blank" :href="IMGURL + item.url">{{ item.name }}</a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import Commondtitle from '../Commondtitle'
    import axios from '../../assets/js/baseaxios'
    import baseUrl from '../../assets/js/baseUrl'
    export default {
        name: "detailInfo",
        data(){
            return{
                IMGURL: '',
                id: this.$route.query.id,
                name: '',
                dataObj: {},
                fujian: false,
            }
        },
        mounted(){
            this.IMGURL = baseUrl.IMG_URL
            if(this.$route.query.name === 'info'){
                this.name = '信息公告'
                this.getInfoData()
            }else if(this.$route.query.name === 'law'){
                this.name = '法律法规'
                this.getLawData()
            }
        },
        methods:{
            getInfoData(){
                axios.get(`/api/message/${this.id}`).then(res=>{
                    if(res.data.success){
                        let items = res.data.items[0]
                        if(items.fmessageFileUrl.length === 0){
                            this.fujian = false
                        }else{
                            this.fujian = true
                        }
                        let tag = items.fmessageFileUrl.split(',')
                        items.fmessageFileUrl2 = tag.map(btn=>{
                            return {
                                name: btn.slice(btn.replace(/(.*\/)*([^.]+).*/ig,"$1").length),
                                url: btn
                            }
                        })
                        this.dataObj = items
                    }else{
                        this.$message.warning(res.data.msg)
                    }
                })
            },
            getLawData(){
                axios.get(`/api/law/${this.id}`).then(res=>{
                    if(res.data.success){
                        let items = res.data.items[0]

                        if(items.flawFileUrl.length === 0){
                            this.fujian = false
                        }else{
                            this.fujian = true
                        }
                        let tag = items.flawFileUrl.split(',').filter(btn=>{
                            return btn.length !== 0
                        })
                        items.flawFileUrl2 = tag.map(btn=>{
                            return {
                                name: btn.slice(btn.replace(/(.*\/)*([^.]+).*/ig,"$1").length),
                                url: btn
                            }
                        })
                        this.dataObj = items
                    }else{
                        this.$message.warning(res.data.msg)
                    }
                })
            },
        },
        components:{
            Commondtitle
        }
    }
</script>

<style scoped>
    .deatilInfo{
        width: 100%;
         /*min-height: 500px;*/
    }
    .dea_content{
        width: 1100px;
        margin: 0 auto;
        min-height: 300px;
    }
    .dea_content h2{
        color: #333;
        font-size: 30px;
        line-height: 40px;
        margin-bottom: 20px;
    }
    .dea_content p{
        font-size: 14px;
        line-height: 19px;
        color: #333;
        margin-bottom: 40px;
    }
    .dea_content img{
        display: block;
        width: 800px;
        height: 400px;
        margin: 0 auto 40px;
    }
    .dea_fujian{
        width: 1100px;
        margin: 0 auto 100px;
        display: flex;
    }
    .dea_fujian p{
        line-height: 19px;
        width: 42px;
        min-width: 42px;
        line-height: 22px;
        color: #333;
        font-size: 14px;
        margin-right: 10px;
    }
    .dea_fujian ul{
        width: 1048px;
    }
    .dea_fujian ul li{
        float: left;
        margin-right: 40px;
    }
    .dea_fujian ul li a{
        color: #00B76B;
        line-height: 22px;
        font-size: 14px;
    }
</style>